import { render, staticRenderFns } from "./AssignLoansModal.vue?vue&type=template&id=0bbeabc0&scoped=true&"
import script from "./AssignLoansModal.vue?vue&type=script&lang=js&"
export * from "./AssignLoansModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignLoansModal.vue?vue&type=style&index=0&id=0bbeabc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbeabc0",
  null
  
)

export default component.exports